import LinkWithConfirmationModal from './link-with-confirmation-modal';
export default LinkWithConfirmationModal;
